var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"loader",style:({ fontSize: `${_vm.size}px` })})
}
var staticRenderFns = []

export { render, staticRenderFns }